import { CALCULATORS_NAMES } from '../components/prescriptionPad/rightPanel/workspace/calculatorsTypes';
import {
    GAdvice,
    GDiaTemplate,
    GDyForm,
    GExamination,
    GExaminationsTemplate,
    GFollowUp,
    GInjection,
    GInjectionTemplate,
    GLTTemplate,
    GLabTest,
    GLabVitalEntity,
    GLabVitalTemplate,
    GMedFrequency,
    GMedSOA,
    GMedTemplate,
    GMedTiming,
    GMedication,
    GPTemplate,
    GProceduresTemplate,
    GRefer,
    GService,
    GSymTemplate,
    GSymptomsDiagnosis,
    GVitals,
    SectionNameConfig,
} from '../store/db';
import { MEDICAL_HISTORY_CATEGORY, MHItem } from '../store/types/medicalHistory';
import { GMedicalRecordsTags } from '../store/types/prescription';

import { PUSH_GENIE } from './constants';
import { DFormEntity } from './fetchDoctorGenieByOID';
import { StorageInfoResponse } from './fetchStorageInfo';
import fetchWithRefresh from './fetchWithRefresh';
import { PrintConfig, Translate } from './pushVisit';

export type GeniePadElementsSettingItem = {
    id: string;
    name: string;
    isShown: boolean;
    isAutoCopy?: boolean;
};

export type GenieMemoryItem = {
    id: string;
    remember: boolean;
};

export type GenieMemoryCustomItem = {
    sectionId: string;
    isSectionEnabled: boolean;
    rememberNotes: boolean;
};

export type AddPtDFormSettingItem = DFormEntity & { isShown: boolean };
export type MedicalHistorySectionSettingsItem = MedicalHistorySection & { isShown: boolean };
export type CalculatorsConfigSectionSettingsItem = CalculatorsConfigItemsType & {
    isShown: boolean;
};

export interface GenieMemoryConfig {
    medications?: GenieMemoryItem[];
    injections?: GenieMemoryItem[];
    labTests?: GenieMemoryItem[];
    isMedicationsEnabled?: boolean;
    isInjectionsEnabled?: boolean;
    isLabTestEnabled?: boolean;
    customSections?: GenieMemoryCustomItem[];
}

export interface MessageConfigType {
    id: string;
    title: string;
    summary: string;
    status: boolean;
}
export type GeniePtColumns = string[];
export type GenieSettings = {
    betaSchedule: boolean;
    openPrintPdfInNewTab: boolean;
    sendWelcome: boolean;
    dform: boolean;
    messageConfig: MessageConfigType[];
    smartSuggestions: boolean;
    showVaccinationChart: boolean;
    padElements: GeniePadElementsSettingItem[];
    medElements: GeniePadElementsSettingItem[];
    injectionTableConfig: GeniePadElementsSettingItem[];
    autoFillFollowUp: boolean;
    barcodeEnabled: boolean;
    isHEDeactivated: boolean;
    twinHealthEnabled: boolean;
    hxngPreferredLabPartnerId: string[];
    isHealthWeekDoctor: boolean;
    abdm: boolean;
    propertiesFocusSkip: boolean;
    medTypeIds: string[];
    showMedicalHistoryInAddPt: boolean;
    anf: boolean;
    hideNewHxngFlow: boolean;
    icdSuggestion: boolean;
    growthChart: boolean;
    isSendAbhaOtp: boolean;
    isHxngPatientConsent: boolean;
    hidePatientHealthSummary: boolean;
    showMilestone: boolean;
    disableAutoScrollOnSelect: boolean;
    meetDocAssistDisabled: boolean;
    medsCopilot: boolean;
    saEnabled: boolean;
    isDoseCalculatorAvailable: boolean;
    bizLevelPt: boolean;
    admissionToIPDEnabled: boolean;
    showVoiceToRxPopover: boolean;
    genieMemoryConfig: GenieMemoryConfig;
    medRouteEnabled: boolean;
};

export type GMedicalHistoryConfig = MedicalHistoryConfig;
export type GCalculatorsConfig = CalculatorsConfig;
export type GVitalConfig = VitalsConfig;

export type MedicalHistorySection = {
    label: string;
    type: 'string';
    key: MEDICAL_HISTORY_CATEGORY;
};

export type MedicalHistoryConfig = {
    commonItems: MHItem[] | [];
    sections: MedicalHistorySection[] | [];
};

export type CalculatorsConfigItemsType = {
    label: string;
    type: 'string';
    key: CALCULATORS_NAMES;
};

export type CalculatorsConfig = {
    selectedItems: CalculatorsConfigItemsType[];
};

export type VitalsSelectedItemsType = {
    id: string;
    name: string;
    defaultOptionId?: string;
};

export type VitalsConfig = {
    selectedItems: VitalsSelectedItemsType[];
};

export type ALL_PT = 'ALL_PT';
export type START_VISIT = 'START_VISIT';
export type PAY_DASH = 'PAY_DASH';
export type PAY_DASH_BEYOND_TODAY = 'PAY_DASH_BEYOND_TODAY';
export type DEFAULT = 'DEFAULT';
export type DOWNLOAD_PATIENT_EXCEL = 'DOWNLOAD_PATIENT_EXCEL';
export type EDIT_RECEIPT = 'EDIT_RECEIPT';
export type PATIENT_REGISTRATION = 'PATIENT_REGISTRATION';
export type PATIENT_DATABASE = 'PATIENT_DATABASE';
export type VITALS_COLLECTION = 'VITALS_COLLECTION';
export type CAN_REQUEST_RECORDS = 'CAN_REQUEST_RECORDS';
export type AVAILABILITY = 'AVAILABILITY';
export type SKU_CREATE = 'SKU_CREATE';
export type SKU_EDIT = 'SKU_EDIT';
export type SERVICES = 'SERVICES';
export type RECEIPT_EDIT = 'RECEIPT_EDIT';
export type DAILY_FINANCE_OVERVIEW_STRIP = 'DAILY_FINANCE_OVERVIEW_STRIP';
export type PACKAGES = 'PACKAGES';
export type DOWNLOAD_QUEUE = 'DOWNLOAD_QUEUE';
export type SETTINGS_AND_PREFERENCES = 'SETTINGS_AND_PREFERENCES';
export type PROFILE_MANAGEMENT = 'PROFILE_MANAGEMENT';
export type ROLES_AND_PERMISSIONS = 'ROLES_AND_PERMISSIONS';
export type ANALYTICS = 'ANALYTICS';
export type PAYOUT_REPORTS = 'PAYOUT_REPORTS';
export type CAN_CREATE_RECEIPT_WITH_APT = 'CAN_CREATE_RECEIPT_WITH_APT';
export type PAYMENT_ID_IN_RECEIPT = 'PAYMENT_ID_IN_RECEIPT';
export type HXNG_ORDERS = 'HXNG_ORDERS';
export type EDIT_RX = 'EDIT_RX';
export type LEFT_BLOCK_ON_NEW_QUEUE = 'LEFT_BLOCK_ON_NEW_QUEUE';
export type GO_TO_OLD_QUEUE = 'GO_TO_OLD_QUEUE';
export type MY_ACCOUNT = 'MY_ACCOUNT';
export type PATIENT_MOBILE_NUMBER = 'PATIENT_MOBILE_NUMBER';
export type DELETE_RECEIPT = 'DELETE_RECEIPT';
export type ADD_PATIENT_ADDRESS = 'ADD_PATIENT_ADDRESS';
export type UPLOAD_MEDICAL_RECORDS = 'UPLOAD_MEDICAL_RECORDS';
export type ABHA = 'ABHA';
export type SA = 'SA';
export type TREATMENT = 'TREATMENT';
export type REFER_PATIENT_TO_DOCTOR = 'REFER_PATIENT_TO_DOCTOR';
export type SEND_GOOGLE_REVIEW = 'SEND_GOOGLE_REVIEW';
export type SEND_ATTACHMENT = 'SEND_ATTACHMENT';
export type REQUEST_VITALS = 'REQUEST_VITALS';
export type SEND_PAYMENT_LINK = 'SEND_PAYMENT_LINK';
export type SEND_RX_VIA_OWN_WA = 'SEND_RX_VIA_OWN_WA';
export type SEND_RX = 'SEND_RX';
export type CREATE_CUSTOM_QUEUE = 'CREATE_CUSTOM_QUEUE';
export type DOC_ASSIST = 'DOC_ASSIST';
export type CREATE_MEDICAL_DOCUMENTS = 'CREATE_MEDICAL_DOCUMENTS';
export type EKA_CREDITS = 'EKA_CREDITS';
export type MERGE_PATIENTS = 'MERGE_PATIENTS';
export type APPOINTMENT_WIDGET = 'APPOINTMENT_WIDGET';
export type PT_DETAILS_VISIT_ACTIONS = 'PT_DETAILS_VISIT_ACTIONS';
export type EDIT_QUEUE = 'EDIT_QUEUE';
export type CAN_CREATE_RX_TEMPLATE = 'CAN_CREATE_RX_TEMPLATE';
export type CUSTOMIZE_RX_TEMPLATE = 'CUSTOMIZE_RX_TEMPLATE';
export type REQUEST_TRAINING = 'REQUEST_TRAINING';
export type BUSINESS_ANALYTICS = 'BUSINESS_ANALYTICS';
export type GENIE_DASHBOARD = 'GENIE_DASHBOARD';
export type PATIENT_REFERRALS_DASHBOARD = 'PATIENT_REFERRALS_DASHBOARD';
export type APPOINTMENTS_CALENDAR_VIEW = 'APPOINTMENTS_CALENDAR_VIEW';
export type INVITE_CODE = 'INVITE_CODE';
export type DELETE_APPOINTMENT = 'DELETE_APPOINTMENT';
export type APT_FIELD_PAYMENT_STATUS = 'APT_FIELD#PAYMENT_STATUS';
export type GLOBAL_SEARCH = 'GLOBAL_SEARCH';

export enum SRE {
    DEFAULT = 'DEFAULT',
    ALL_PT = 'ALL_PT',
    START_VISIT = 'START_VISIT',
    PAY_DASH = 'PAY_DASH',
    DOWNLOAD_PATIENT_EXCEL = 'DOWNLOAD_PATIENT_EXCEL',
    PAY_DASH_BEYOND_TODAY = 'PAY_DASH_BEYOND_TODAY',
    EDIT_RECEIPT = 'EDIT_RECEIPT',
    RECEIPT_EDIT = 'RECEIPT_EDIT',
}
export enum SREV2 {
    ALL_PT = 'ALL_PT',
    START_VISIT = 'START_VISIT',
    PAY_DASH = 'PAY_DASH',
    DOWNLOAD_PATIENT_EXCEL = 'DOWNLOAD_PATIENT_EXCEL',
    PAY_DASH_BEYOND_TODAY = 'PAY_DASH_BEYOND_TODAY',
    EDIT_RECEIPT = 'EDIT_RECEIPT',
    PATIENT_REGISTRATION = 'PATIENT_REGISTRATION',
    PATIENT_DATABASE = 'PATIENT_DATABASE',
    VITALS_COLLECTION = 'VITALS_COLLECTION',
    CAN_REQUEST_RECORDS = 'CAN_REQUEST_RECORDS',
    AVAILABILITY = 'AVAILABILITY',
    SKU_CREATE = 'SKU_CREATE',
    SKU_EDIT = 'SKU_EDIT',
    SERVICES = 'SERVICES',
    RECEIPT_EDIT = 'RECEIPT_EDIT',
    DAILY_FINANCE_OVERVIEW_STRIP = 'DAILY_FINANCE_OVERVIEW_STRIP',
    PACKAGES = 'PACKAGES',
    DOWNLOAD_QUEUE = 'DOWNLOAD_QUEUE',
    SETTINGS_AND_PREFERENCES = 'SETTINGS_AND_PREFERENCES',
    PROFILE_MANAGEMENT = 'PROFILE_MANAGEMENT',
    ROLES_AND_PERMISSIONS = 'ROLES_AND_PERMISSIONS',
    ANALYTICS = 'ANALYTICS',
    PAYOUT_REPORTS = 'PAYOUT_REPORTS',
    CAN_CREATE_RECEIPT_WITH_APT = 'CAN_CREATE_RECEIPT_WITH_APT',
    PAYMENT_ID_IN_RECEIPT = 'PAYMENT_ID_IN_RECEIPT',
    HXNG_ORDERS = 'HXNG_ORDERS',
    EDIT_RX = 'EDIT_RX',
    LEFT_BLOCK_ON_NEW_QUEUE = 'LEFT_BLOCK_ON_NEW_QUEUE',
    GO_TO_OLD_QUEUE = 'GO_TO_OLD_QUEUE',
    MY_ACCOUNT = 'MY_ACCOUNT',
    PATIENT_MOBILE_NUMBER = 'PATIENT_MOBILE_NUMBER',
    DELETE_RECEIPT = 'DELETE_RECEIPT',
    ADD_PATIENT_ADDRESS = 'ADD_PATIENT_ADDRESS',
    UPLOAD_MEDICAL_RECORDS = 'UPLOAD_MEDICAL_RECORDS',
    ABHA = 'ABHA',
    SA = 'SA',
    TREATMENT = 'TREATMENT',
    REFER_PATIENT_TO_DOCTOR = 'REFER_PATIENT_TO_DOCTOR',
    SEND_GOOGLE_REVIEW = 'SEND_GOOGLE_REVIEW',
    SEND_ATTACHMENT = 'SEND_ATTACHMENT',
    REQUEST_VITALS = 'REQUEST_VITALS',
    SEND_PAYMENT_LINK = 'SEND_PAYMENT_LINK',
    SEND_RX_VIA_OWN_WA = 'SEND_RX_VIA_OWN_WA',
    SEND_RX = 'SEND_RX',
    CREATE_CUSTOM_QUEUE = 'CREATE_CUSTOM_QUEUE',
    DOC_ASSIST = 'DOC_ASSIST',
    CREATE_MEDICAL_DOCUMENTS = 'CREATE_MEDICAL_DOCUMENTS',
    EKA_CREDITS = 'EKA_CREDITS',
    MERGE_PATIENTS = 'MERGE_PATIENTS',
    APPOINTMENT_WIDGET = 'APPOINTMENT_WIDGET',
    PT_DETAILS_VISIT_ACTIONS = 'PT_DETAILS_VISIT_ACTIONS',
    EDIT_QUEUE = 'EDIT_QUEUE',
    CAN_CREATE_RX_TEMPLATE = 'CAN_CREATE_RX_TEMPLATE',
    CUSTOMIZE_RX_TEMPLATE = 'CUSTOMIZE_RX_TEMPLATE',
    REQUEST_TRAINING = 'REQUEST_TRAINING',
    BUSINESS_ANALYTICS = 'BUSINESS_ANALYTICS',
    GENIE_DASHBOARD = 'GENIE_DASHBOARD',
    PATIENT_REFERRALS_DASHBOARD = 'PATIENT_REFERRALS_DASHBOARD',
    APPOINTMENTS_CALENDAR_VIEW = 'APPOINTMENTS_CALENDAR_VIEW',
    INVITE_CODE = 'INVITE_CODE',
    DELETE_APPOINTMENT = 'DELETE_APPOINTMENT',
    APT_FIELD_PAYMENT_STATUS = 'APT_FIELD#PAYMENT_STATUS',
    GLOBAL_SEARCH = 'GLOBAL_SEARCH',
}

export type SR =
    | DEFAULT
    | ALL_PT
    | START_VISIT
    | PAY_DASH
    | DOWNLOAD_PATIENT_EXCEL
    | PAY_DASH_BEYOND_TODAY
    | EDIT_RECEIPT
    | RECEIPT_EDIT;
export type SRV2 =
    | ALL_PT
    | START_VISIT
    | PAY_DASH
    | DOWNLOAD_PATIENT_EXCEL
    | PAY_DASH_BEYOND_TODAY
    | EDIT_RECEIPT
    | PATIENT_REGISTRATION
    | PATIENT_DATABASE
    | VITALS_COLLECTION
    | CAN_REQUEST_RECORDS
    | AVAILABILITY
    | SKU_CREATE
    | SKU_EDIT
    | SERVICES
    | RECEIPT_EDIT
    | DAILY_FINANCE_OVERVIEW_STRIP
    | PACKAGES
    | DOWNLOAD_QUEUE
    | SETTINGS_AND_PREFERENCES
    | PROFILE_MANAGEMENT
    | ROLES_AND_PERMISSIONS
    | ANALYTICS
    | PAYOUT_REPORTS
    | CAN_CREATE_RECEIPT_WITH_APT
    | PAYMENT_ID_IN_RECEIPT
    | HXNG_ORDERS
    | EDIT_RX
    | LEFT_BLOCK_ON_NEW_QUEUE
    | GO_TO_OLD_QUEUE
    | MY_ACCOUNT
    | PATIENT_MOBILE_NUMBER
    | DELETE_RECEIPT
    | ADD_PATIENT_ADDRESS
    | UPLOAD_MEDICAL_RECORDS
    | ABHA
    | SA
    | TREATMENT
    | REFER_PATIENT_TO_DOCTOR
    | SEND_GOOGLE_REVIEW
    | SEND_ATTACHMENT
    | REQUEST_VITALS
    | SEND_PAYMENT_LINK
    | SEND_RX_VIA_OWN_WA
    | SEND_RX
    | CREATE_CUSTOM_QUEUE
    | DOC_ASSIST
    | CREATE_MEDICAL_DOCUMENTS
    | EKA_CREDITS
    | MERGE_PATIENTS
    | APPOINTMENT_WIDGET
    | PT_DETAILS_VISIT_ACTIONS
    | EDIT_QUEUE
    | CAN_CREATE_RX_TEMPLATE
    | CUSTOMIZE_RX_TEMPLATE
    | REQUEST_TRAINING
    | BUSINESS_ANALYTICS
    | GENIE_DASHBOARD
    | PATIENT_REFERRALS_DASHBOARD
    | APPOINTMENTS_CALENDAR_VIEW
    | INVITE_CODE
    | DELETE_APPOINTMENT
    | APT_FIELD_PAYMENT_STATUS
    | GLOBAL_SEARCH;

export type StaffRestriction = SR[];

export interface PushGeniePayload {
    id: string;
    advices?: GAdvice[];
    diagnosis?: GSymptomsDiagnosis[];
    labTests?: GLabTest[];
    vitals?: GVitals[];
    medications?: GMedication[];
    injections?: GInjection[];
    symptoms?: GSymptomsDiagnosis[];
    templates?: GPTemplate[];
    ltTemplates?: GLTTemplate[];
    medTemplates?: GMedTemplate[];
    injectionTemplates?: GInjectionTemplate[];
    labVitalsTemplates?: GLabVitalTemplate[];
    symTemplates?: GSymTemplate[];
    diaTemplates?: GDiaTemplate[];
    examinations?: GExamination[];
    examinationsTemplates?: GExaminationsTemplate[];
    followUp?: GFollowUp[];
    refer?: GRefer[];
    printConfig?: PrintConfig;
    ptColumns?: GeniePtColumns;
    settings?: GenieSettings;
    medicalHistoryConfig?: MedicalHistoryConfig;
    vitalsConfig?: VitalsConfig;
    calculatorConfig?: CalculatorsConfig;
    sectionNameConfig?: SectionNameConfig;
    services?: GService[];
    translate?: Translate;
    padDForms?: GDyForm[];
    medFrequency?: GMedFrequency[];
    medSOA?: GMedSOA[];
    medTiming?: GMedTiming[];
    labVitals?: GLabVitalEntity[];
    staffRestriction?: StaffRestriction;
    version?: number;
    keyVitals?: string[];
    extraFlags?: ExtraFlags;
    medicalRecordsTags?: GMedicalRecordsTags[];
    proceduresTemplates?: GProceduresTemplate[];
    groupAccess?: {
        enabled?: boolean;
    };
}

export interface ExtraFlags {
    substitution?: boolean;
    balance?: number;
    abha_potential_loss?: number;
    storageInfo?: StorageInfoResponse;
    currentMonthLoss?: number;
    claimableAmount?: IClaimableAmount[];
}

export interface IClaimableAmount {
    amount: number;
    clinic_id: string;
    closed_at?: string;
    closed?: boolean;
}

export type GenieKeys = keyof PushGeniePayload;

export default (docid: string, dump: PushGeniePayload): Promise<Response> => {
    return fetchWithRefresh(PUSH_GENIE(docid), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            keys: Object.keys(dump).join(','),
        },
        body: JSON.stringify(dump),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('doc profile not found or no updates');
        }
    });
};
